// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsie-header-container {
  width: 100%;
  display: flex;
  background-color: ghostwhite;
  max-height: 50px;
  justify-content: left;
  align-items: center;
  padding-left: 1vw;
  padding-right: 2vw;

}

.hamburger-icon {
  margin-top: 9%;
}

.hamburger-menu-icon {
  margin-top: 10%;
  background-color: rgba(136, 137, 148, 0.055);
  border-radius: 5px;
  border: 1px;
  border-color: rgba(169, 169, 169, 0.466);
  border-style: solid;
  margin-bottom: 4px;
}

.header-newsie-title{
  display: flex;
  flex-direction: row;
  gap: 2px;
  margin: auto;
  font-size: 1.3em;
  margin-left: 10px;
  margin-top: 12%;
}

.newsie-menu-icon-container {
  flex-direction: row;
  display: flex;
  margin-left: 1%;
}

.newsie-header-middle {
  flex: 2.3 1;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 80%;
  margin-left: 10%;
}

.instructions-question-icon-layout {
  max-height: 90%;
  display: flex;
  flex:1 1;
  justify-content: center;
  margin-top: 1%;
  padding: 10px;
}


.instructions-question-icon {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.instructions-clue-icon {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.newsie-header-clue-button-container {
  width:50%;
}

.newsie-header-clue-button-container.no-clue {
  display: none;
}

.newsie-header-clue-button-container.strobe {
  background-color: rgba(42, 85, 165, 0.137);
  animation: flickerAnimation 2s infinite;
  border-radius: 10%;
}

.newsie-header-clue-button-layout {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.newsie-header-clue-button {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-right: 5%;
  font-size: .75em;
}

.newsie-header-clue-button-text {
  font-weight: 900;
  font-size: xx-small;
  margin: 3px;
}

.instructions-question-icon-container {
  border-style: solid;
  border-width: .5px;
  border-color: rgba(169, 169, 169, 0.705);
  padding: 1%;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(255, 0, 0, 0.096);
  min-width: 50px;
  background-color: rgba(136, 137, 148, 0.055);
  margin-bottom: 3px;
}

@keyframes flickerAnimation {
  0%   { opacity:1; }
  50%  { opacity:0.2; }
  100% { opacity:1; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/NewsieHeader/Header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAS;EACT,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAM;EACN,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;;AAGA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAI1C,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,OAAO,SAAS,EAAE;EAClB,OAAO,WAAW,EAAE;EACpB,OAAO,SAAS,EAAE;AACpB","sourcesContent":[".newsie-header-container {\n  width: 100%;\n  display: flex;\n  background-color: ghostwhite;\n  max-height: 50px;\n  justify-content: left;\n  align-items: center;\n  padding-left: 1vw;\n  padding-right: 2vw;\n\n}\n\n.hamburger-icon {\n  margin-top: 9%;\n}\n\n.hamburger-menu-icon {\n  margin-top: 10%;\n  background-color: rgba(136, 137, 148, 0.055);\n  border-radius: 5px;\n  border: 1px;\n  border-color: rgba(169, 169, 169, 0.466);\n  border-style: solid;\n  margin-bottom: 4px;\n}\n\n.header-newsie-title{\n  display: flex;\n  flex-direction: row;\n  gap: 2px;\n  margin: auto;\n  font-size: 1.3em;\n  margin-left: 10px;\n  margin-top: 12%;\n}\n\n.newsie-menu-icon-container {\n  flex-direction: row;\n  display: flex;\n  margin-left: 1%;\n}\n\n.newsie-header-middle {\n  flex: 2.3;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  height: 80%;\n  margin-left: 10%;\n}\n\n.instructions-question-icon-layout {\n  max-height: 90%;\n  display: flex;\n  flex:1;\n  justify-content: center;\n  margin-top: 1%;\n  padding: 10px;\n}\n\n\n.instructions-question-icon {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.instructions-clue-icon {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.newsie-header-clue-button-container {\n  width:50%;\n}\n\n.newsie-header-clue-button-container.no-clue {\n  display: none;\n}\n\n.newsie-header-clue-button-container.strobe {\n  background-color: rgba(42, 85, 165, 0.137);\n  -webkit-animation: flickerAnimation 2s infinite;\n  -moz-animation: flickerAnimation 2s infinite;\n  -o-animation: flickerAnimation 2s infinite;\n  animation: flickerAnimation 2s infinite;\n  border-radius: 10%;\n}\n\n.newsie-header-clue-button-layout {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.newsie-header-clue-button {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-right: 5%;\n  font-size: .75em;\n}\n\n.newsie-header-clue-button-text {\n  font-weight: 900;\n  font-size: xx-small;\n  margin: 3px;\n}\n\n.instructions-question-icon-container {\n  border-style: solid;\n  border-width: .5px;\n  border-color: rgba(169, 169, 169, 0.705);\n  padding: 1%;\n  border-radius: 5px;\n  box-shadow: 1px 1px 1px rgba(255, 0, 0, 0.096);\n  min-width: 50px;\n  background-color: rgba(136, 137, 148, 0.055);\n  margin-bottom: 3px;\n}\n\n@keyframes flickerAnimation {\n  0%   { opacity:1; }\n  50%  { opacity:0.2; }\n  100% { opacity:1; }\n}\n@-o-keyframes flickerAnimation{\n  0%   { opacity:1; }\n  50%  { opacity:0.2; }\n  100% { opacity:1; }\n}\n@-moz-keyframes flickerAnimation{\n  0%   { opacity:1; }\n  50%  { opacity:0.2; }\n  100% { opacity:1; }\n}\n@-webkit-keyframes flickerAnimation{\n  0%   { opacity:1; }\n  50%  { opacity:0.2; }\n  100% { opacity:1; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
